<template>
  <div class="page">
    <div class="page-content">
  		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Import Direct Payments Report" popoverName=".popoverReportDP"></page-nav-bar>
      <div class="row">
      </div>
      <div class="layoutSubtitle"/>
      <f7-list class="searchbar-not-found">
        <f7-list-item title="Nothing found"></f7-list-item>
      </f7-list>
      <div class="webdatalist">
        <f7-list class="searchbar-found polsize" id="bank-list" media-list>
          <f7-list-item>
            <b-row>
              <b-col cols="2" offset-md="1"><h2><b-badge variant="light" style="background-color:#EFEFEF;color:black">All {{countAll}}</b-badge></h2></b-col>
              <b-col cols="2"><h2><b-badge variant="light" style="background-color:#EFEFEF;color:black"><f7-icon fa="check" color="green"></f7-icon> {{countSuccess}}</b-badge></h2></b-col>
              <b-col cols="2"><h2><b-badge variant="light" style="background-color:#EFEFEF;color:black"><f7-icon fa="exclamation-triangle" color="yellow"></f7-icon> {{countWarning}}</b-badge></h2></b-col>
              <b-col cols="2"><h2><b-badge variant="light" style="background-color:#EFEFEF;color:black"><f7-icon fa="close" color="red"></f7-icon> {{countError}}</b-badge></h2></b-col>
              <b-col cols="2"><h2><b-badge variant="light" style="background-color:#EFEFEF;color:black"><f7-icon fa="refresh" color="black"></f7-icon> {{countOther}}</b-badge></h2></b-col>
            </b-row>
            <!-- <b-table-simple slot="inner" bordered stripped>
              <b-tbody>
                <b-tr>
                  <b-td>Total</b-td>
                  <b-td><f7-icon fa="check" color="green"></f7-icon></b-td>
                  <b-td><f7-icon fa="exclamation-triangle" color="yellow"></f7-icon></b-td>
                  <b-td><f7-icon fa="close" color="red"></f7-icon></b-td>
                  <b-td><f7-icon fa="refresh" color="black"></f7-icon></b-td>
                </b-tr>
                <b-tr>
                  <b-td>24</b-td>
                  <b-td>18</b-td>
                  <b-td>1</f7-icon></b-td>
                  <b-td>3</f7-icon></b-td>
                  <b-td>2</f7-icon></b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple> -->
          </f7-list-item>
          <f7-list-item v-for="(entry, index) in report"
            :title="entry.reason"
            :subtitle="entry.creditorName"
            :key="'rep-' + index">
            <span slot="after">{{entry.amount}} {{entry.currency}}</span>
            <f7-icon slot="media" :fa="getIcon(entry.done)" :color="getColor(entry.done)"></f7-icon>
          </f7-list-item>
        </f7-list>
      </div>
    </div>
  </div>
</template>

<script>

import pageNavBar from '@/components/common/pageNavBar.vue'

export default {
  name: 'ImportBankAccountReportList',
  components: {
    'page-nav-bar': pageNavBar
  },
  data: () => {
    return {
      report: [],
      tests: [{
        creditorIdentifier: 'ines.ryder@streammind.com',
        creditorName: 'Ines Ryder',
        creditorBankAccount: 'FR2710096000409212672524V25',
        debtorIdentifier: 'ellmo.rivetti@streammind.com',
        debtorName: 'Ellmo Rivetti',
        debtorBankAccount: 'FR142001010115050001',
        amount: '20',
        currency: 'EUR',
        executionDate: '2019-02-10',
        reason: 'Test CSV 1',
        endToEndId: '',
        creditorZoneCode: 'EU',
        debtorZoneCode: 'EU',
        attachmentName: 'DP.csv',
        attachmentReference: 'DPdata',
        attachmentData: 'data:application/vnd.ms-excel;base64,aW5lcy5yeWRlckBzdHJlYW1taW5kLmNvbTtJbsOocyBSeWRlcjtGUjI3MTAwOTYwMDA0MDkyMTI2NzI1MjRWMjU7O2VsbG1vLnJpdmV0dGlAc3RyZWFtbWluZC5jb207RWxsbW8gUml2ZXR0aTtGUjE0MjAwMTAxMDExNTA1MDAwMTs7MjA7RVVSOzIwMTktMDItMTA7QmVjYXVzZSB3aHkgbm90ID87O0VVO0VVO0RQLmNzdjtEUGRhdGE7WTNKbFpHbDBiM0pKWkdWdWRHbG1hV1Z5TzJOeVpXUnBkRzl5VG1GdFpUdGpjbVZrYVhSdmNrSmhibXRCWTJOdmRXNTBPenRrWldKMGIzSkpaR1Z1ZEdsbWFXVnlPMlJsWW5SdmNrNWhiV1U3WkdWaWRHOXlRbUZ1YTBGalkyOTFiblE3TzJGdGIzVnVkRHRqZFhKeVpXNWplVHRsZUdWamRYUnBiMjVFWVhSbE8zSmxZWE52Ymp0RmJtUlViMFZ1WkVsa08wSXlRanREZFhKeVpXNTBSR0YwWlR0aGRIUmhZMmh0Wlc1MFRtRnRaVHRoZEhSaFkyaHRaVzUwVW1WbVpYSmxibU5sTzJGMGRHRmphRzFsYm5Sa1lYUmhPM04wWVhSMWN6dGpjbVZrYVhSdmNscHZibVZEYjJSbE8yUmxZblJ2Y2xwdmJtVkRiMlJsDQo=',
        done: 'wrong'
      },
      {
        creditorIdentifier: 'ines.ryder@streammind.com',
        creditorName: 'Ines Ryder',
        creditorBankAccount: 'FR2710096000409212672524V25',
        debtorIdentifier: 'ellmo.rivetti@streammind.com',
        debtorName: 'Ellmo Rivetti',
        debtorBankAccount: 'FR142001010115050001',
        amount: '20',
        currency: 'EUR',
        executionDate: '2019-02-10',
        reason: 'Test CSV 2',
        endToEndId: '',
        creditorZoneCode: 'EU',
        debtorZoneCode: 'EU',
        attachmentName: 'DP.csv',
        attachmentReference: 'DPdata',
        attachmentData: 'data:application/vnd.ms-excel;base64,aW5lcy5yeWRlckBzdHJlYW1taW5kLmNvbTtJbsOocyBSeWRlcjtGUjI3MTAwOTYwMDA0MDkyMTI2NzI1MjRWMjU7O2VsbG1vLnJpdmV0dGlAc3RyZWFtbWluZC5jb207RWxsbW8gUml2ZXR0aTtGUjE0MjAwMTAxMDExNTA1MDAwMTs7MjA7RVVSOzIwMTktMDItMTA7QmVjYXVzZSB3aHkgbm90ID87O0VVO0VVO0RQLmNzdjtEUGRhdGE7WTNKbFpHbDBiM0pKWkdWdWRHbG1hV1Z5TzJOeVpXUnBkRzl5VG1GdFpUdGpjbVZrYVhSdmNrSmhibXRCWTJOdmRXNTBPenRrWldKMGIzSkpaR1Z1ZEdsbWFXVnlPMlJsWW5SdmNrNWhiV1U3WkdWaWRHOXlRbUZ1YTBGalkyOTFiblE3TzJGdGIzVnVkRHRqZFhKeVpXNWplVHRsZUdWamRYUnBiMjVFWVhSbE8zSmxZWE52Ymp0RmJtUlViMFZ1WkVsa08wSXlRanREZFhKeVpXNTBSR0YwWlR0aGRIUmhZMmh0Wlc1MFRtRnRaVHRoZEhSaFkyaHRaVzUwVW1WbVpYSmxibU5sTzJGMGRHRmphRzFsYm5Sa1lYUmhPM04wWVhSMWN6dGpjbVZrYVhSdmNscHZibVZEYjJSbE8yUmxZblJ2Y2xwdmJtVkRiMlJsDQo=',
        done: 'success'
      },
      {
        creditorIdentifier: 'ines.ryder@streammind.com',
        creditorName: 'Ines Ryder',
        creditorBankAccount: 'FR2710096000409212672524V25',
        debtorIdentifier: 'ellmo.rivetti@streammind.com',
        debtorName: 'Ellmo Rivetti',
        debtorBankAccount: 'FR142001010115050001',
        amount: '20',
        currency: 'EUR',
        executionDate: '2019-02-10',
        reason: 'Test CSV 3',
        endToEndId: '',
        creditorZoneCode: 'EU',
        debtorZoneCode: 'EU',
        attachmentName: 'DP.csv',
        attachmentReference: 'DPdata',
        attachmentData: 'data:application/vnd.ms-excel;base64,aW5lcy5yeWRlckBzdHJlYW1taW5kLmNvbTtJbsOocyBSeWRlcjtGUjI3MTAwOTYwMDA0MDkyMTI2NzI1MjRWMjU7O2VsbG1vLnJpdmV0dGlAc3RyZWFtbWluZC5jb207RWxsbW8gUml2ZXR0aTtGUjE0MjAwMTAxMDExNTA1MDAwMTs7MjA7RVVSOzIwMTktMDItMTA7QmVjYXVzZSB3aHkgbm90ID87O0VVO0VVO0RQLmNzdjtEUGRhdGE7WTNKbFpHbDBiM0pKWkdWdWRHbG1hV1Z5TzJOeVpXUnBkRzl5VG1GdFpUdGpjbVZrYVhSdmNrSmhibXRCWTJOdmRXNTBPenRrWldKMGIzSkpaR1Z1ZEdsbWFXVnlPMlJsWW5SdmNrNWhiV1U3WkdWaWRHOXlRbUZ1YTBGalkyOTFiblE3TzJGdGIzVnVkRHRqZFhKeVpXNWplVHRsZUdWamRYUnBiMjVFWVhSbE8zSmxZWE52Ymp0RmJtUlViMFZ1WkVsa08wSXlRanREZFhKeVpXNTBSR0YwWlR0aGRIUmhZMmh0Wlc1MFRtRnRaVHRoZEhSaFkyaHRaVzUwVW1WbVpYSmxibU5sTzJGMGRHRmphRzFsYm5Sa1lYUmhPM04wWVhSMWN6dGpjbVZrYVhSdmNscHZibVZEYjJSbE8yUmxZblJ2Y2xwdmJtVkRiMlJsDQo=',
        done: 'error'
      },
      {
        creditorIdentifier: 'ines.ryder@streammind.com',
        creditorName: 'Ines Ryder',
        creditorBankAccount: 'FR2710096000409212672524V25',
        debtorIdentifier: 'ellmo.rivetti@streammind.com',
        debtorName: 'Ellmo Rivetti',
        debtorBankAccount: 'FR142001010115050001',
        amount: '20',
        currency: 'EUR',
        executionDate: '2019-02-10',
        reason: 'Test CSV 4',
        endToEndId: '',
        creditorZoneCode: 'EU',
        debtorZoneCode: 'EU',
        attachmentName: 'DP.csv',
        attachmentReference: 'DPdata',
        attachmentData: 'data:application/vnd.ms-excel;base64,aW5lcy5yeWRlckBzdHJlYW1taW5kLmNvbTtJbsOocyBSeWRlcjtGUjI3MTAwOTYwMDA0MDkyMTI2NzI1MjRWMjU7O2VsbG1vLnJpdmV0dGlAc3RyZWFtbWluZC5jb207RWxsbW8gUml2ZXR0aTtGUjE0MjAwMTAxMDExNTA1MDAwMTs7MjA7RVVSOzIwMTktMDItMTA7QmVjYXVzZSB3aHkgbm90ID87O0VVO0VVO0RQLmNzdjtEUGRhdGE7WTNKbFpHbDBiM0pKWkdWdWRHbG1hV1Z5TzJOeVpXUnBkRzl5VG1GdFpUdGpjbVZrYVhSdmNrSmhibXRCWTJOdmRXNTBPenRrWldKMGIzSkpaR1Z1ZEdsbWFXVnlPMlJsWW5SdmNrNWhiV1U3WkdWaWRHOXlRbUZ1YTBGalkyOTFiblE3TzJGdGIzVnVkRHRqZFhKeVpXNWplVHRsZUdWamRYUnBiMjVFWVhSbE8zSmxZWE52Ymp0RmJtUlViMFZ1WkVsa08wSXlRanREZFhKeVpXNTBSR0YwWlR0aGRIUmhZMmh0Wlc1MFRtRnRaVHRoZEhSaFkyaHRaVzUwVW1WbVpYSmxibU5sTzJGMGRHRmphRzFsYm5Sa1lYUmhPM04wWVhSMWN6dGpjbVZrYVhSdmNscHZibVZEYjJSbE8yUmxZblJ2Y2xwdmJtVkRiMlJsDQo=',
        done: 'NA'
      }
      ]
    }
  },
  created () {
    this.report = this.$engine.services.directPayments.getReport()
  },
  computed: {
    countAll () {
      return this.report.length
    },
    countSuccess () {
      return this.report.filter(entry => entry.done === 'success').length
    },
    countWarning () {
      return this.report.filter(entry => entry.done === 'wrong').length
    },
    countError () {
      return this.report.filter(entry => entry.done === 'error').length
    },
    countOther () {
      let count = this.report.filter(entry => !['success', 'wrong', 'error'].includes(entry.done)).length
      if (count === 0) {
        this.$f7.alert('', 'Import Ended')
      }
      return count
    }
  },
  methods: {
    getIcon (done) {
      switch (done) {
        case 'success':
          return 'check'
        case 'error':
          return 'close'
        case 'wrong':
          return 'exclamation-triangle'
        default:
          return 'refresh'
      }
    },
    getColor (done) {
      switch (done) {
        case 'success':
          return 'green'
        case 'error':
          return 'red'
        case 'wrong':
          return 'yellow'
        default:
          return 'black'
      }
    }
  }
}
</script>

<style>

</style>
